import { useTheme } from "@mui/material";
import { Box, Text } from "designSystem/index";
import React, { FunctionComponent } from "react";
import { useChannelListStyles } from "./styles";

const NoChannelPlaceholder: FunctionComponent = () => {
	const { emptyInside, emptyRoot } = useChannelListStyles(useTheme());

	return (
		<Box sx={emptyRoot}>
			<Box p={3} sx={emptyInside}>
				<Text res="NoChannelsFoundLabel" />
			</Box>
		</Box>
	);
};

export default NoChannelPlaceholder;